interface Anio {
  value: string;
  label: string;
}

const getAnios = (cantAnios = 30): Anio[] => {
  const year = new Date().getFullYear();

  let result: Anio[] = [];
  for (let i = year; i > year - cantAnios; i--) {
    result.push({
      value: i.toString(),
      label: i.toString(),
    });
  }

  return result;
};

export default getAnios;
